import React from 'react';
import { Link } from 'react-router-dom';
import { Home, Search, ArrowLeft } from 'lucide-react';

export default function NotFound() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-sky-50 via-white to-teal-50 flex items-center justify-center px-4" data-testid="not-found-page">
      <div className="text-center max-w-md">
        <div className="text-8xl font-black text-teal-500 mb-4">404</div>
        <h1 className="text-2xl md:text-3xl font-black text-gray-900 mb-3">
          Page Not Found
        </h1>
        <p className="text-gray-500 mb-8">
          Looks like this route doesn't exist. Let's get you back on track to plan your next adventure.
        </p>
        <div className="flex flex-col sm:flex-row gap-3 justify-center">
          <Link
            to="/"
            className="flex items-center justify-center gap-2 px-6 py-3 bg-gradient-to-r from-teal-500 to-cyan-500 text-white font-bold shadow-lg shadow-teal-500/30 hover:shadow-xl hover:scale-105 transition-all"
            style={{ borderRadius: '9999px' }}
            data-testid="go-home-btn"
          >
            <Home size={18} />
            Go Home
          </Link>
          <Link
            to="/planning"
            className="flex items-center justify-center gap-2 px-6 py-3 bg-white text-gray-700 font-bold border-2 border-gray-200 hover:border-teal-300 hover:text-teal-600 shadow-lg transition-all"
            style={{ borderRadius: '9999px' }}
            data-testid="plan-trip-btn"
          >
            <Search size={18} />
            Plan a Trip
          </Link>
        </div>
      </div>
    </div>
  );
}
